import React from "react";
import PropTypes from "prop-types";
import "components/Header/Header.css";
import { useSelector } from "react-redux";

//To be shown on top of screens.
function Header(props) {
  const { className: customClassName, isUserDetailsPage } = props;
  const clDetails = useSelector((state) => state.clDetailsReducer);
  return (
    <div>
      {" "}
      {isUserDetailsPage ? (
        <header style={{background:clDetails.primaryColor}} className="user-details-header">
          <div className="header-left-section">{props.children}</div>
        </header>
      ) : (
        <header style={{background:clDetails.primaryColor}} className={customClassName}>
          <div className="header-left-section">{props.children[0]}</div>
          <div className="header-right-section-first">{props.children[1]}</div>
        </header>
      )}
    </div>
  );
}

Header.propTypes = {
  children: PropTypes.arrayOf(PropTypes.any),
};

export default Header;
